import React, { useState } from "react";

const Checkboxes = ({ options, index, answer = [], disabled = true, other }) => {
  const [val, setValue] = useState([]);
  
  let otherOption = { ...other, answer: "Other" };
  let renderOptions = other ? [...options, otherOption] : options;

  const handleChange = (e) => {
    e.target.checked ? setValue(prev => [...prev, e.target.value]) : setValue(prev => prev.filter(it => it !== e.target.value));
  }

  return (
    <div className="uk-form-controls uk-margin-small-top">
      {renderOptions
        ?.filter((option) => !option.deleted)
        .map((option, i) => (
          <div key={i}>
            <label htmlFor={`survey${index}-${i}`} className="hms-checkbox">
              <input
                type="checkbox"
                value={option.answer}
                onChange={handleChange}
                id={`survey${index}-${i}`}
                name={`checkbox${index}`}
                disabled={disabled}
                defaultChecked={answer.indexOf(option.answer) > -1}
              />
              <span className="hms-checkmark"></span>
              {option.answer}
            </label>
          </div>
        ))}
        {
          val.includes("Other") && <div className="uk-form-controls uk-margin-small-top">
            <textarea
              className="uk-textarea uk-width-2-3"
              rows="3"
            >
              {answer}
            </textarea>
          </div>
        }
    </div>
  );
};

export default Checkboxes;
